var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.942,
    height: 59.943,
    viewBox: "0 0 59.942 59.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6642\\u8A08\\u306E\\u7121\\u6599\\u30A2\\u30A4\\u30B3\\u30F3",
    transform: "translate(-0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M177.167,166.768l7.59,5.855.106.061.047.026a1.738,1.738,0,0,0,2.1-.466l.051-.048,9.3-11.005a1.262,1.262,0,1,0-1.868-1.662l-8.7,9.289-6.713-4.675a1.644,1.644,0,0,0-1.924,2.625Z",
    transform: "translate(-155.953 -140.385)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M64.623,246.954a11.211,11.211,0,0,1,.051-1.2H59.91c-.029.394-.037.8-.037,1.2s.008.805.037,1.2h4.764A11.236,11.236,0,0,1,64.623,246.954Z",
    transform: "translate(-52.859 -216.984)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M153.19,87.061c.45-.285.91-.554,1.377-.793l.182-.088-2.374-4.123a18.386,18.386,0,0,0-1.734,1l2.375,4.125Z",
    transform: "translate(-132.999 -72.45)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M82.071,152.368l4.125,2.374,1-1.732-4.126-2.375A18.43,18.43,0,0,0,82.071,152.368Z",
    transform: "translate(-72.458 -132.999)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M387.046,326.392c-.248.468-.508.926-.8,1.37l-.119.174,4.126,2.375c.365-.562.7-1.131,1-1.725l-4.115-2.383Z",
    transform: "translate(-340.915 -288.013)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M86.283,326.386l-.1-.181-4.116,2.374a17.09,17.09,0,0,0,1,1.733l4.126-2.375-.12-.174A14.96,14.96,0,0,1,86.283,326.386Z",
    transform: "translate(-72.458 -288.014)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M153.19,386.231l-.175-.119-2.375,4.126a18.747,18.747,0,0,0,1.734,1.005l2.374-4.125-.182-.088A15.135,15.135,0,0,1,153.19,386.231Z",
    transform: "translate(-132.999 -340.907)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M326.214,86.174l1.734,1.005,2.375-4.125a18.442,18.442,0,0,0-1.725-1Z",
    transform: "translate(-288.017 -72.451)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M245.771,410.747v4.758c.4.035.8.043,1.2.043s.8-.008,1.2-.043V410.7h-2.4Z",
    transform: "translate(-216.992 -362.615)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M248.167,64.669V59.911c-.394-.035-.8-.043-1.2-.043s-.8.008-1.2.043v4.808h2.4Z",
    transform: "translate(-216.992 -52.859)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M326.214,387.125l2.384,4.117c.592-.309,1.163-.641,1.725-1.005l-2.375-4.126Z",
    transform: "translate(-288.017 -340.906)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M391.257,152.368a18.663,18.663,0,0,0-1-1.733l-4.126,2.375,1.007,1.732Z",
    transform: "translate(-340.915 -132.999)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M415.526,245.757h-4.813v2.4h4.813c.03-.4.036-.8.036-1.2S415.556,246.151,415.526,245.757Z",
    transform: "translate(-362.624 -216.985)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M29.976,0A29.972,29.972,0,1,0,59.947,29.972,29.971,29.971,0,0,0,29.976,0Zm0,56.076A26.1,26.1,0,1,1,48.435,48.43,26.01,26.01,0,0,1,29.976,56.076Z",
    fill: "#4b4b4b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.261d58c3fb323ad0b9fdbd0f8bc00a1c.svg";
export { ForwardRef as ReactComponent };